import { Prop, Watch } from "vue-property-decorator";
import IOperationsHistoryService from "../../services/history/IOperationsHistoryService";
import { StatementItemModel } from "../../models/statement/statementItemModel";
import { StatementModel } from "../../models/statement/statementModel";
import { RequestParamsModel } from "../../models/statement/requestParamsModel";
import { HistoryStatus } from "../../data/enums/HistoryStatus";
import IAlertService from "../../services/alert/IAlertService";
import { getModule } from "vuex-module-decorators";
import { CatalogStore } from "../../store/modules/catalog";
import { ContractsStore } from "../../store/modules/contracts";
import { AppStore } from "../../store/modules/app";
import { container } from "@/inversify.config";
import { searchCatalogById } from "../../utilities/index"
import { jsUcfirst } from "../../utilities/index";
import { DiTokens } from "../../services/diTokens";
import i18n from "@/i18n";
import Vue from "vue";

export class OperationsListVue extends Vue {
  @Prop() model!: StatementModel;

  @Prop() isPeriod!: boolean;

  @Prop() saveEnable!: boolean;

  @Prop() showRest!: boolean;

  @Prop() contractFilter!: boolean;

  @Prop() statusFilter!: boolean;

  @Prop() hideOperationsFilter!: boolean;

  @Prop() isCardAccountHistory!: boolean;

  /** Период месяцев */
  months: Array<any> = [];

  searchValue: string = '';

  /** Флаг скрывания пикера */
  showPicker: boolean = false;

  compKey: number = 0;

  /** Список операций */
  operations: Array<StatementItemModel> = [];

  /** Значение фильтра операций */
  filter: string = "all";

  /** Выбранная категория операций в диаграмме */
  activeCategory: string = "";

  /** Загрузка файла выписки */
  saveFileLoading: boolean = false;

  /** Показывать линию или диграмму */
  chartHidden: boolean = false;

  /** Информация в модальном окне операции */
  modalDetails: any = null;

  modalLoading: boolean = false;

  /** Флаг отображния модального окна операции */
  operInfoDialog: boolean = false;

  localeMonths: Array<string> = Object.keys(i18n.t("common.months")).map(
    (item: string) => {
      return i18n.t(`common.months.${item}`).toString();
    }
  );

  loading: boolean = true;

  /** Отслеживание изменения значение периода месяцев */
  @Watch("months", { immediate: true })
  async monthsChanged() {
    if (this.months.length > 0) {
      if (new Date(this.months[0]) > new Date(this.months[1])) {
        const boofer = this.months[0];
        this.months[0] = this.months[1];
        this.months[1] = boofer;
      }
      this.model.operationsList = await this.getOpeationsList("");
      // if (this.$route.query.operId) {
      //   const operation: any = this.model.operationsList.find((oper: any) => oper.Id == this.$route.query.operId);
      //   if (operation)
      //     this.showOperInfoDialog(operation);
      //   else
      //     this.showOperInfoDialog({ Id: this.$route.query.operId, ReferenceId: ''});
      //   this.appStore.setLoading(false);
      // }
    }
  }

  @Watch("model", { immediate: true })
  modelIninitiated(val: any) {
    if (this.model) {
      this.init();
      this.showPicker = false;
    }
  }

  setQuery(e: any) {
    if (e.query)
      this.searchValue = e.query;
  }

  get dynamicService(): IOperationsHistoryService {
    return container.get<IOperationsHistoryService>(this.model.token);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**Стор настроек */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /**Стор настроек */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  /**Стор настроек */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  operImageURL(operation: StatementItemModel): string {
    if (operation.Picture)
      return operation.Picture;
    return searchCatalogById(this.catalogStore.catalog, operation.Id)?.Picture ?? "";
  }

  async getStatementFile() {
    this.saveFileLoading = true;
    const fileUrl: string = await this.dynamicService.getStatementFile(
      +this.$route.params.cardId
        ? +this.$route.params.cardId
        : +this.$route.params.contractId,
      this.months[0],
      this.months[1]
    );
    if (fileUrl.length > 0) {
      const a = document.createElement("a");
      a.setAttribute('href', fileUrl);
      a.setAttribute('target', '_blank');
      a.click();
      a.remove();
    } else {
      this.alertService.error(
        i18n.t("main.operations.errors.loadStatementError").toString()
      );
    }
    this.saveFileLoading = false;
  }

  /** Фильтрация массива операций (пока фильтр отсуствует) */
  get getFilteredArray(): Array<StatementItemModel> {
    if (this.model.operationsList)
      return this.model.operationsList.filter(item =>
        this.operationsFilterCondition(item)
      );
    return [];
  }

  /** Ответ на событие изменения активной категории emit(changeActiveCategory) */
  activeCategoryChange(val: any) {
    this.activeCategory = val;
  }

  /** Ответ на событие свертывания графика emit(chartToggle) */
  toggleChart(e: any) {
    this.chartHidden = e.isShow;
  }

  /** Фильтрация списка операций */
  operationsFilterCondition(operation: any) {
    if (
      this.filter === "all" ||
      (this.filter === "exp" && operation.Sum < 0) ||
      (this.filter === "rec" && operation.Sum > 0)
    ) {
      let flag = false;
      for (const key in operation) {
        if (operation[key] === this.activeCategory) flag = true;
      }
      if (this.activeCategory === null || flag) return true;
    } else return false;
  }

  /** Ответ на событие изменения фильтра emit(filterChange) */
  async filterValue(e: any) {
    if (e.category) {
      this.filter = e.category;
    } else if (e.status) {
      this.model.operationsList = await this.getOpeationsList(
        "",
        e.status,
        this.model.filterContractId
      );
    } else if (e.contract === null || e.contract) {
      this.model.operationsList = await this.getOpeationsList(
        "",
        this.model.status,
        e.contract
      );
    }
  }

  /** Изменение значения периода */
  changeMonthVal(e: any) {
    this.months = e.period;
  }

  /** Изменение значения флага пикера */
  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  /** Получение периода дат в текстовом формате */
  get periodText() {
    if (this.months.length > 0 && (this.isPeriod || this.model.isPeriod)) {
      const first = this.months[0]?.split('-').reverse().join(".");
      const second = this.months[1]?.split('-').reverse().join(".");

      return `${first ? first : ''}${first && second ? ' - ' : ''}${second ? second : ''}`;
    } else if (this.months[0] && !this.model.isPeriod) {
      const month: string = jsUcfirst(
        this.localeMonths[+this.months[0].substring(5, 7) - 1]
      );
      const year: number = +this.months[0].substring(0, 4);
      return year === new Date().getFullYear() ? month : `${month} ${year}`;
    }
    return "";
  }

  /** Получние минимальной даты */
  get getMinDate(): string {
    if (!this.model.minDate || this.model.minDate === "-")
      return new Date(2010, 0, 2).toISOString().substr(0, 10);
    return new Date(this.model.minDate).toISOString().substr(0, 10);
  }

  async showOperInfoDialog(operation: any) {
    this.modalLoading = true;
    this.operInfoDialog = true;
    this.modalDetails = await this.dynamicService.getOperationDetails(
      operation
    );
    this.modalLoading = false;
  }

  /** Получние максимальной даты */
  get getMaxDate(): string {
    if (!this.model)
      return;
    const contract: any = this.contractsStore.contracts.getContract(+this.$route.params.contractId);
    if (
      !this.model.maxDate ||
      this.model.maxDate === "-" ||
      (new Date(this.model.maxDate) > new Date() && contract?.Data?.ContractType !== 5)
    )
      return new Date().toISOString().substr(0, 10);
    return new Date(this.model.maxDate).toISOString().substr(0, 10);
  }

  /** Поиск операций */
  async searchOperations(e: any) {
    if (e.query === null) {
      this.model.operationsList = await this.getOpeationsList('');
      this.searchValue = '';
    } else {
      this.model.operationsList = await this.getOpeationsList(e.query);
    }
  }

  /** Инициализация списка */
  async init() {
    this.compKey += 1;
    this.months = [];
    const contract: any = this.contractsStore.contracts.getContract(+this.$route.params.contractId);
    if (this.model && this.model.months.length > 0) {
      this.model.months.map((v: any) => this.months.push(v));
    } else if (this.model && contract?.Data?.ContractType !== 5) {
      const first = this.getMaxDate.substring(0, 8) + "01";
      this.months.push(first);
      this.months.push(this.getMaxDate);
    } else if (this.model && contract?.Data?.ContractType == 5) {
      const first = new Date().toISOString().substr(0, 8) + "01";
      this.months.push(first);
      this.months.push(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10));
    }
  }

  async refreshList(e: any) {
    e.stopPropagation();
    this.model.operationsList = await this.getOpeationsList(
      "",
      this.model.status,
      this.model.filterContractId,
      true
    );
  }

  async getOpeationsList(
    text: string,
    status: HistoryStatus = 31,
    contract: string | null = null,
    isRefresh: boolean = false
  ): Promise<Array<StatementItemModel>> {
    const monthsMatch = this.model.months.filter(
      (v: any, i: number) => v === this.months[i]
    ).length;

    if (!isRefresh) {
      if (
        monthsMatch === 2 &&
        this.model.status === status &&
        this.model.filterContractId === contract &&
        text.length < 3
      ) {
        this.loading = false;
        return this.model.operationsList;
      }
    }

    this.loading = true;
    this.model.months = [];
    this.model.status = status;
    this.model.filterContractId = contract;
    this.months.map((month: string) => this.model.months.push(month));

    let contractId = +this.$route.params.cardId
      ? this.$route.params.cardId
      : this.$route.params.contractId;

    if (contract) {
      contractId = contract;
    }

    if (!contractId && this.$route.name !== 'OperationsHistory') {
      contractId = this.contractsStore.selectedCardOrContract;
    }

    const resObj: any = await this.dynamicService.getOperationsHistory(
      new RequestParamsModel({
        dateBegin: this.months[0],
        dateEnd: this.months[1],
        contractId: contractId,
        take: 1000,
        searchText: text,
        sortType: 1,
        filter: this.model.status,
        rootCatalog: this.catalogStore.catalog,
        contractType: this.model.contractType,
        isCardAccountHistory: this.isCardAccountHistory ?? false
      })
    );

    if (this.showRest) {
      this.model.RestIn = resObj.RestIn;
      this.model.RestOut = resObj.RestOut;
    }

    this.loading = false;
    return this.showRest ? resObj.list : resObj;
  }
}
